export default __webpack_public_path__ + "static/media/igp.6a14e638.png";